export const calculatePriceBasedOnFat = (animalType, fat) => {
    if (!fat) return ""; // No fat input, no price calculation
  
    let price = 0;
    let fatValue = parseFloat(fat);
  
    // Adjust fat value if it is greater than 13
    if (fatValue > 13) {
      fatValue /= 10;
    }
  
    if (animalType === "cow") {
      // Retrieve cow fat prices from local storage
      const cowFatPrices = localStorage.getItem("Cow_fatPrices");
      if (!cowFatPrices) return "0.00"; // If not present, return default value
  
      const parsedPrices = JSON.parse(cowFatPrices);
      const priceBelow35 = parsedPrices.below35;
      const priceAbove35 = parsedPrices.above35;
  
      if (fatValue < 3.5) {
        price = (priceBelow35 * fatValue) / 10;
      } else {
        price = (priceAbove35 * fatValue) / 10;
      }
    } else {
      // Retrieve buffalo fat prices from local storage
      const buffaloFatPrices = localStorage.getItem("Buffalo_fatPrices");
      if (!buffaloFatPrices) return "0.00"; // If not present, return default value
  
      const parsedPrices = JSON.parse(buffaloFatPrices);
      const priceOn100 = parsedPrices.fat100;
      price = (priceOn100 / 10) * fatValue;
    }
  
    return price.toFixed(2);
  };
  

  export const calculatePriceBasedOnFatAndSNF = (animalType, fat, snf) => {
    if (!fat || !snf) return ""; // No fat or SNF input, no price calculation
    
    let fatValue = parseFloat(fat);
    let snfValue = parseFloat(snf);
  
    // Adjust fat and SNF values if they are greater than 10
    if (fatValue > 10) {
      fatValue /= 10;
    }
    if (snfValue > 10) {
      snfValue /= 10;
    }
  
    // Round to the nearest integer
    fatValue = Math.round(fatValue);
    snfValue = Math.round(snfValue);
  
    // Adjust values to match 1-based indexing
    const fatIndex = fatValue - 1;
    const snfIndex = snfValue - 1;
  
    if (fatIndex < 0 || snfIndex < 0) return "0.00"; // Invalid values (e.g., negative or zero)
  
    // Determine the correct local storage key
    const localStorageKey = animalType === "cow" ? "Cow" : "Buffalo";
    
    // Check if the local storage list is present; if not, return "0.00"
    const storedData = localStorage.getItem(localStorageKey);
    if (!storedData) {
      return "0.00";
    }
    
    const storedPrices = JSON.parse(storedData);
  
    if (
      storedPrices &&
      storedPrices.length > snfIndex && // Ensure SNF index is within bounds
      storedPrices[snfIndex] &&
      storedPrices[snfIndex].length > fatIndex // Ensure Fat index is within bounds
    ) {
      const price = parseFloat(storedPrices[snfIndex][fatIndex]) || 0;
      return price.toFixed(2);
    }
  
    // Return default value if conditions are not met
    return "0.00";
  };